import { render, staticRenderFns } from "./ResponseDialog.vue?vue&type=template&id=52c72c82&scoped=true"
import script from "./ResponseDialog.vue?vue&type=script&lang=js"
export * from "./ResponseDialog.vue?vue&type=script&lang=js"
import style0 from "./ResponseDialog.vue?vue&type=style&index=0&id=52c72c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c72c82",
  null
  
)

export default component.exports